import styled from 'styled-components';

type ContainerProps = {
  background: string;
  width: string;
};

export const SearchContainer = styled.div<ContainerProps>`
  display: flex;
  align-items: center;
  position: relative;
  width: ${(props) => props.width};
  background-color: ${(props) => props.background};
  border: 1px solid ${(props) => props.theme.colors.solidButton};
  border-radius: 5px;
  height: 40px;
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  padding: 0 10px;
  
  svg {
    font-size: 20px;
    color: ${(props) => props.theme.colors.textTitle};
  }
`;

export const Input = styled.input`
  flex-grow: 1;
  
  background: none;
  border: none;
  outline: none;
  height: 100%;
  
  color: #a6a6a6;
  font-size: 12px;
  font-family: Roboto, sans-serif;
  font-weight: 600;
  letter-spacing: 1px;
  
  &::placeholder {
    color: ${(props) => props.theme.colors.textTitle};
    font-weight: 600;
  }
  
  &:focus::placeholder {
    color: #a6a6a6;
  }

  &:hover {
    font-style: italic;
  }
`;